import { render } from "./FilesList.vue?vue&type=template&id=3cf8c5f7&scoped=true"
import script from "./FilesList.vue?vue&type=script&lang=js"
export * from "./FilesList.vue?vue&type=script&lang=js"

import "./FilesList.vue?vue&type=style&index=0&id=3cf8c5f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf8c5f7"]])

export default __exports__